import React from 'react';
import PropTypes from 'prop-types';
import { IconButton } from '../../controls/Controls';

const SortItemRenderer = ({ actions, title }) => {
  return (
    <div className="sort-item-renderer">
      <div className="title-wrapper">{title}</div>

      {actions && (
        <div className="actions-wrapper">
          {actions.map((action) => (
            <IconButton
              key={action.id}
              tooltip={action.tooltip}
              onClick={action.onClick}
              icon={action.icon}
              disabled={action.disabled}
            />
          ))}
        </div>
      )}
    </div>
  );
};

SortItemRenderer.propTypes = {
  actions: PropTypes.array, // { onClick, title, icon }
};

export default SortItemRenderer;
